module.exports = __webpack_public_path__ + "assets/img/back_btn.8f153da7.svg";